var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6377 0C7.76011 0 3.80078 3.95933 3.80078 8.83689C3.80078 13.7145 7.76011 17.6738 12.6377 17.6738C17.5152 17.6738 21.4746 13.7145 21.4746 8.83689C21.4746 3.95933 17.5152 0 12.6377 0ZM12.6377 1.26241C16.8178 1.26241 20.2122 4.65679 20.2122 8.83689C20.2122 13.017 16.8178 16.4114 12.6377 16.4114C8.45757 16.4114 5.06319 13.017 5.06319 8.83689C5.06319 4.65679 8.45757 1.26241 12.6377 1.26241Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.004 5.63856V13.2565C12.004 13.6052 12.2864 13.8877 12.6352 13.8877C12.9831 13.8877 13.2664 13.6052 13.2664 13.2565V5.63856L16.3616 8.7338C16.6078 8.97998 17.0078 8.97998 17.254 8.7338C17.5002 8.48762 17.5002 8.0876 17.254 7.84142C17.254 7.84142 14.9304 5.51697 13.7508 4.33737C13.4549 4.0415 13.0533 3.875 12.6351 3.875C12.2161 3.875 11.8153 4.04148 11.5187 4.33737C10.3075 5.54928 10.6665 5.19029 7.99724 7.8596C7.75027 8.10578 7.75027 8.5058 7.99724 8.75198C8.24342 8.99816 8.64343 8.99816 8.88961 8.75198L12.004 5.63856Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.481 25.0018H1.52026C0.682137 25.0018 0 24.3234 0 23.4904V22.0348C0 21.2016 0.682137 20.5234 1.52026 20.5234H23.481C24.3191 20.5234 25.0009 21.2016 25.0009 22.0348V23.4904C25.0009 24.3234 24.3191 25.0018 23.481 25.0018ZM1.52026 20.8171C0.844916 20.8171 0.295425 21.3634 0.295425 22.0348V23.4901C0.295425 24.1618 0.844916 24.7078 1.52026 24.7078H23.481C24.156 24.7078 24.7055 24.1618 24.7055 23.4901V22.0348C24.7055 21.3634 24.1566 20.8171 23.481 20.8171H1.52026Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89266 21.082C1.16089 21.082 0.567383 21.5702 0.567383 22.1717V23.3342C0.567383 23.9365 1.16089 24.4241 1.89266 24.4241H2.61911L5.95623 21.0823H1.89266V21.082Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18166 21.082L3.84424 24.4238H8.80059L12.138 21.082H7.18166Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3625 21.082L10.0254 24.4238H14.9814L18.3183 21.082H13.3625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProgress);
export default __webpack_public_path__ + "static/media/uploadProgress.961a4a4bb7374d69fd5c5d550ff59f1a.svg";
export { ForwardRef as ReactComponent };